import { InfoOutlined } from "@mui/icons-material";
import { Popover, Typography } from "@mui/material";
import { useDebugMode } from "components/DebugContext/DebugContext";
import { format } from "date-fns";
import { useState } from "react";

interface InstanceRunningIndicatorProps {
  instanceId: string;
  instanceRunningStartTime: number;
  instanceDuration: number;
  instanceTimeLeft: number;
  runningInstanceIndicatorOnClick: () => void;
}

export const InstanceRunningIndicator = ({
  instanceId,
  instanceRunningStartTime,
  instanceDuration,
  instanceTimeLeft,
  runningInstanceIndicatorOnClick,
}: InstanceRunningIndicatorProps) => {
  const { debugMode } = useDebugMode();
  const getInstanceRunningTime = () => {
    const displayTime = instanceTimeLeft > 0 ? instanceTimeLeft : 0;
    const totalSeconds = Math.floor(displayTime / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}:${String(seconds).padStart(2, "0")}`;
  };

  const [anchorPopover, setAnchorPopover] = useState(null);
  const handleOpenPopover = (event) => {
    setAnchorPopover(event.currentTarget);
  };
  const handleClosePopover = () => {
    setAnchorPopover(null);
  };
  const openPopover = Boolean(anchorPopover);
  const popoverId = openPopover ? "details-popover" : undefined;

  if (instanceId === null) {
    console.log("instanceId is null, returning null");
    return null;
  }

  return (
    <div className="fixed bottom-[50px] left-[38px] z-[101] flex flex-row items-center gap-1">
      <button
        onClick={runningInstanceIndicatorOnClick}
        className="px-4 py-2 bg-[#ad566c] rounded-full shadow-lg transition duration-150 ease-in-out text-white hover:bg-[#c97a8e]"
        title={`Go to running instance ${instanceId}`}
      >
        Instance Running - {getInstanceRunningTime()}
      </button>
      {debugMode && (
        <div className="flex items-center">
          <button
            aria-describedby={popoverId}
          onClick={handleOpenPopover}
          className="p-1 bg-[#ad566c] rounded-full shadow-lg transition duration-150 ease-in-out text-white hover:bg-[#c97a8e]"
          title="Instance Details"
        >
          <InfoOutlined fontSize="small" />
        </button>
        <Popover
          id={popoverId}
          open={openPopover}
          anchorEl={anchorPopover}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "8px",
              boxShadow: "0px 7px 29px 0px rgba(100, 100, 111, 0.20)!important",
              padding: "10px",
              minWidth: "200px",
            },
          }}
        >
          <Typography variant="body2">Instance ID: {instanceId}</Typography>
          <Typography variant="body2">
            Started: {instanceRunningStartTime ? format(new Date(instanceRunningStartTime), "Pp") : "N/A"}
          </Typography>
          <Typography variant="body2">
            Duration: {instanceDuration ? `${instanceDuration} mins` : "N/A"}
          </Typography>
          <Typography variant="body2">
            Time Left: {getInstanceRunningTime()}
            </Typography>
          </Popover>
        </div>
      )}
    </div>
  );
};